var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-0",attrs:{"justify":"center","align":"center"}},[_c('processing-evaluate-card',{ref:"processing-evaluate-card"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }